import { selectCurrentHotelName } from 'accessors'
import { generateShortNameAndBrand } from 'actions'
import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'
import Checkbox from 'components/ReusableComponents/Checkbox'
import CustomHeader from 'components/ReusableComponents/HeaderTitles'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import Dropdown from 'components/ReusableComponents/ManageHotel/Dropdown'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import PmsLoginResultDialog from 'features/PMSLogin/TryLoginDialog'
import { PMSs } from 'main/hotelBrandsAndChains'
import { useEffect } from 'react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'
import { formatPhoneNumber, phoneValRegex } from 'utils/helpers'

import GXPLogin from './GXPLogin'
import PMSLogo from './helpers/PMSLogo'
import OHIPPMSLogin from './OHIPPMSLogin'
import styles from './PMSLogin.module.scss'

const PMSsRequirePhone = [PMSs.marriottgxp]

const PMSsRequirePropertyId = [
  PMSs.webrezpro,
  PMSs.visualmatrix,
  PMSs.roomkey,
  PMSs.jonaschorum,
  PMSs.ohip,
  PMSs.clock,
  PMSs.maestro,
  PMSs.infor,
  PMSs.destiworld,
  PMSs.synxis,
  PMSs.mews
]

const PMSsRequireChainCode = [PMSs.synxis]

const PMSsRequireApiKey = [PMSs.roomkey, PMSs.jonaschorum, PMSs.cloudbeds]

const PMSsRequireAccountId = [PMSs.clock, PMSs.mews, PMSs.hotelkey]

const PMSsRequireUserName = [
  PMSs.choiceadvantage,
  PMSs.skytouch,
  PMSs.marriottgxp,
  PMSs.webrezpro,
  PMSs.resnexus,
  PMSs.jonaschorum,
  PMSs.ohip,
  PMSs.clock,
  PMSs.mews,
  PMSs.hotelkey
]

const PMSsRequirePassword = [
  PMSs.choiceadvantage,
  PMSs.skytouch,
  PMSs.marriottgxp,
  PMSs.webrezpro,
  PMSs.resnexus,
  PMSs.jonaschorum,
  PMSs.ohip,
  PMSs.mews,
  PMSs.hotelkey
]

const PMSsRequireCLientSecret = [PMSs.clock]

const PMSsRequireRefreshPassword = [PMSs.hotelkey]

const PMSsRequireSubdomain = [PMSs.hotelkey]

const CustomFieldLabels = {
  [PMSs.jonaschorum]: {
    propertyId: 'Customer Code',
    apiKey: 'Subdomain'
  },
  [PMSs.visualmatrix]: {
    propertyId: 'Property Code'
  },

  [PMSs.mews]: {
    userName: 'Access Token',
    password: 'Client Token',
    accountId: 'Client',
    propertyId: 'Enterprise ID'
  },

  [PMSs.hotelkey]: {
    userName: 'Stream Id',
    password: 'Stream Password',
    accountId: 'Refresh Stream Id'
  }
}

const PMSLogin = () => {
  const pms = useSelector(s => s.login.subsidiaryPMS)
  const hotelName = useSelector(selectCurrentHotelName)
  const { shortName, brand } = generateShortNameAndBrand(hotelName)

  const { addToast } = useToasts()

  const [phone, setPhone] = useState('')
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [clientSecret, setClientSecret] = useState('')
  const [apiKey, setApiKey] = useState('')
  const [accountId, setAccountId] = useState('')
  const [propertyId, setPropertyId] = useState('')
  const [pmsChainCode, setPmsChainCode] = useState('')
  const [gmCredentialCheck, setGmCredentialCheck] = useState(false)
  const [isTryingToLogin, setIsTryingToLogin] = useState(false)
  const [tryLoginResponse, setTryLoginResponse] = useState()
  const [refreshPassword, setRefreshPassword] = useState('')
  const [subdomain, setSubdomain] = useState('')
  const [roomkeyHotels, setRoomkeyHotels] = useState()
  const [ohipConfigData, setOhipConfigData] = useState(null)
  const [isOHIPConfigFinazized, setIsOHIPConfigFinazized] = useState(false)
  const [updateConfig, setUpdateConfig] = useState(1)

  function isSaveDisabled() {
    const requiredFields = []

    if (!pms) {
      return
    }

    if (PMSsRequirePhone.includes(pms)) {
      requiredFields.push(phone)
    }

    if (PMSsRequireUserName.includes(pms)) {
      requiredFields.push(userName)
    }

    if (PMSsRequirePassword.includes(pms)) {
      requiredFields.push(password)
    }

    if (PMSsRequireApiKey.includes(pms)) {
      requiredFields.push(apiKey)
    }

    if (PMSsRequirePropertyId.includes(pms)) {
      requiredFields.push(propertyId)
    }

    if (PMSsRequireAccountId.includes(pms)) {
      requiredFields.push(accountId)
    }

    if (PMSsRequireChainCode.includes(pms)) {
      requiredFields.push(pmsChainCode)
    }

    if (PMSsRequirePassword.includes(pms) && !gmCredentialCheck) {
      requiredFields.push(gmCredentialCheck)
    }

    if (PMSsRequireCLientSecret.includes(pms)) {
      requiredFields.push(clientSecret)
    }

    if (PMSsRequireRefreshPassword.includes(pms)) {
      requiredFields.push(refreshPassword)
    }

    if (PMSsRequireSubdomain.includes(pms)) {
      requiredFields.push(subdomain)
    }

    return requiredFields.some(field => !field)
  }

  useEffect(() => {
    if (pms === PMSs.roomkey && apiKey.length === 36) {
      pmsApi.getRoomKeyHotels({ apiKey }).then(res => {
        if (res?.length) {
          setRoomkeyHotels(
            res.reduce((acc, curr) => {
              acc[curr.hotelId] = curr.name
              return acc
            }, {})
          )
          setPropertyId(res[0].hotelId)
        }
      })
    }
  }, [apiKey, pms])

  useEffect(() => {
    if (pms === PMSs.ohip || pms === PMSs.opera || pms === PMSs.operadefault) {
      pmsApi
        .getOhipConfiguration()
        .then(res => setOhipConfigData(res))
        .catch(err => {
          addToast(err, { appearance: 'error' })
        })
    }
  }, [pms, addToast, isOHIPConfigFinazized, updateConfig])

  function onSave() {
    setIsTryingToLogin(true)

    pmsApi
      .login({
        phone: '+1' + phone.replace(/\D/g, ''),
        userName,
        password,
        clientSecret,
        propertyId,
        accountId,
        apiKey,
        pmsChainCode,
        refreshPassword,
        subdomain
      })
      .then(res => {
        setTryLoginResponse(res)
      })
      .catch(() => {
        addToast('Something went wrong', { appearance: 'error' })
      })
      .finally(() => {
        setIsTryingToLogin(false)
      })
  }

  if (pms === PMSs.marriottgxp) {
    return <GXPLogin />
  }

  if (pms === PMSs.ohip || pms === PMSs.opera || pms === PMSs.operadefault) {
    return ohipConfigData ? (
      <>
        <CustomHeader title="PMS Login" subtitle="Opera OHIP" width={1070} />
        <OHIPPMSLogin
          ohipConfigData={ohipConfigData}
          setIsOHIPConfigFinazized={setIsOHIPConfigFinazized}
          setUpdateConfig={setUpdateConfig}
        />
      </>
    ) : (
      <LoadingIndicator />
    )
  }

  if (isTryingToLogin || tryLoginResponse) {
    return (
      <PmsLoginResultDialog
        data={tryLoginResponse}
        isTryingLogin={isTryingToLogin}
        shortName={shortName}
        brand={brand}
        onClose={() => {
          setTryLoginResponse(null)
          setUserName('')
          setPassword('')
          setPropertyId('')
          setPmsChainCode('')
        }}
      />
    )
  }

  return (
    <>
      <div className={styles.wrapper}>
        <CustomHeader title="PMS Sync" width={720} />
        <div className={styles.card}>
          <div className={styles.cardDesc}>
            <div className={styles.logo}>{pms && <PMSLogo pms={pms} />}</div>
            <div className={styles.cardForm}>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  onSave()
                }}
                className={styles.form}
              >
                {PMSsRequirePhone.includes(pms) ? (
                  <TextInput
                    width="100%"
                    className={styles.input}
                    type="tel"
                    label="Phone Number"
                    value={phone}
                    onChangeValue={value => setPhone(formatPhoneNumber(value))}
                    pattern={phoneValRegex}
                    placeholder="(555) 555-5555"
                    required
                  />
                ) : null}
                {PMSsRequireApiKey.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.apiKey || 'API key'}
                    required
                    value={apiKey}
                    onChangeValue={setApiKey}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}
                {PMSsRequireAccountId.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.accountId || 'Account ID'}
                    required
                    value={accountId}
                    onChangeValue={setAccountId}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}
                {PMSsRequirePropertyId.includes(pms) ? (
                  <>
                    {pms === PMSs.roomkey ? (
                      <Dropdown
                        label={CustomFieldLabels[pms]?.propertyId || 'Property ID'}
                        required
                        value={propertyId}
                        onChangeValue={setPropertyId}
                        options={roomkeyHotels}
                        className={styles.input}
                      />
                    ) : (
                      <TextInput
                        label={CustomFieldLabels[pms]?.propertyId || 'Property ID'}
                        required
                        value={propertyId}
                        onChangeValue={setPropertyId}
                        autoComplete="off"
                        className={styles.input}
                      />
                    )}
                  </>
                ) : null}
                {PMSsRequireChainCode.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.pmsChainCode || 'Chain Code'}
                    required
                    value={pmsChainCode}
                    onChangeValue={setPmsChainCode}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}
                {PMSsRequireUserName.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.userName || 'Username'}
                    required
                    value={userName}
                    onChangeValue={setUserName}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}

                {PMSsRequireCLientSecret.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.clientSecret || 'Client Secret'}
                    required
                    value={clientSecret}
                    onChangeValue={setClientSecret}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}

                {PMSsRequireRefreshPassword.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.refreshPassword || 'Refresh Password'}
                    required
                    value={refreshPassword}
                    onChangeValue={setRefreshPassword}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}

                {PMSsRequireSubdomain.includes(pms) ? (
                  <TextInput
                    label={CustomFieldLabels[pms]?.subdomain || 'Subdomain'}
                    required
                    value={subdomain}
                    onChangeValue={setSubdomain}
                    autoComplete="off"
                    className={styles.input}
                  />
                ) : null}

                {PMSsRequirePassword.includes(pms) ? (
                  <>
                    <TextInput
                      label={CustomFieldLabels[pms]?.password || 'Password'}
                      required
                      value={password}
                      onChangeValue={setPassword}
                      autoComplete="off"
                      className={styles.input}
                    />
                    <label className={styles.checkboxLabel}>
                      <Checkbox
                        onChange={e => setGmCredentialCheck(e.target.checked)}
                        checked={gmCredentialCheck}
                      />
                      <span className={styles.checkboxLabelText}>
                        I didn't use GM credentials
                      </span>
                    </label>
                  </>
                ) : null}

                <PrimaryBigButton
                  className={styles.primaryButton}
                  disabled={isSaveDisabled()}
                >
                  Save PMS info
                </PrimaryBigButton>
                <NavLink to="/">
                  <button className={styles.secondaryButton}>Skip for now</button>
                </NavLink>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PMSLogin
